import { render } from "./CheckoutFooter.vue?vue&type=template&id=1decf3c0&ts=true"
import script from "./CheckoutFooter.vue?vue&type=script&lang=ts"
export * from "./CheckoutFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__